import styles from "./WHCButton.module.scss";
import clsx from "clsx";

export default function WHCButton({
  children,
  variant = "primary",
  size = "md",
  type = "button",
  onClick,
  disabled = false,
  icon: Icon,
  iconPosition = "left"
}) {
  return (
    <button
      type={type}
      className={clsx(
        styles.button,
        styles[variant],
        styles[size],
        disabled && styles.disabled,
        Icon && styles.withIcon
      )}
      onClick={onClick}
      disabled={disabled}
    >
        {Icon && iconPosition === "left" && <Icon className={styles.icon} />}
            <span>{children}</span>
        {Icon && iconPosition === "right" && <Icon className={styles.icon} />}
    </button>
  );
}